import React from 'react';
import HeadersWithContentAndImage from 'commonComponents/sections/HeadersWithContentAndImage/HeadersWithContentAndImage';
import BerlinImage from 'oldAssets/images/static_pages/career/live_and_work_in_Berlin.webp';

const LiveAndWork = ({ title, text }) => {

  const textContent = text.map(paragraph => <p key={ paragraph }>{ paragraph }</p>);
  const sectionProps = { title, text, textContent };

  return (
    <HeadersWithContentAndImage
      { ...sectionProps }
      image={ BerlinImage }
      additionalClass="smallText"
      anchor='live-and-work'
    />
  );
};

export default LiveAndWork;
